import { render, staticRenderFns } from "./pagamentoemolumento.vue?vue&type=template&id=35ee64d3&"
import script from "./pagamentoemolumento.vue?vue&type=script&lang=js&"
export * from "./pagamentoemolumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports